import React, { useState, useEffect } from 'react';
import { compareDesc, differenceInDays, format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
//component
import DateSelect from '../Selects/DateSelect';
import { Button } from 'components/Button';
import Text from 'components/Text';
//styles
import { DateFilterContainer } from './styles';

const DateFilter = ({ setDateFilterON }: any) => {
  const dateFilter = useSelector((stateFilter: RootState) => stateFilter.quotesDashboard);
  const dispatch = useDispatch();

  const [disableBtn, setDisableBtn] = useState(true);
  const [disableBtnTooltip, setDisableBtnTooltip] = useState<string>("Selecione uma data");
  const [startDate, setStartDate] = useState(dateFilter?.startDate ? format(new Date(dateFilter.startDate), "yyyy-MM-dd") : '');
  const [endDate, setEndDate] = useState(dateFilter?.endDate ? format(new Date(dateFilter.endDate), "yyyy-MM-dd") : '');

  const formatStartDate = new Date(`${startDate}T00:00:00`);
  const formatEndDate = new Date(`${endDate}T23:59:59`);

  useEffect(() => {
    if (startDate && endDate) {
      const result = compareDesc(formatStartDate, formatEndDate);

      setDisableBtn(true);
      if (result === 1 || result === 0) {
        const daysDiff = differenceInDays(formatEndDate, formatStartDate);
        if (daysDiff <= 90) {
          setDisableBtn(false);
          setDisableBtnTooltip("");
        } else {
          setDisableBtnTooltip("Selecione no máximo 90 dias");
        }
      }

    } else {
      setDisableBtn(true);
    }

  }, [startDate, endDate]);

  const handleSearchButton = () => {
    if (!disableBtn) {
      setDateFilterON(false);
      dispatch({
        type: 'SET_DATES',
        startDate: formatStartDate,
        endDate: formatEndDate,
        filterON: true
      });
    }
  };

  return (
    <DateFilterContainer disable={disableBtn}>
      <div className="container">
        <Text className="section">Filtro por período</Text>

        <div className="selectArea">
          <span className="label">De:</span>
          <div className="dateSelect">
            <DateSelect onChange={setStartDate} value={startDate} />
          </div>
        </div>

        <div className="selectArea">
          <span className="label">Até:</span>
          <div className="dateSelect">
            <DateSelect
              onChange={setEndDate}
              value={endDate}
              minDate={startDate}
            />
          </div>
        </div>

        <div className="buttonArea">
          <div>
            <Button
              width={97}
              className='closeBtn'
              id='close-calendar'
              onClick={() => setDateFilterON(false)}
            >
              Fechar
            </Button>
          </div>

          <div>
            <Button
              width={97}
              className='searchBtn'
              id='search-selected-date'
              tooltip={disableBtnTooltip}
              onClick={() => !disableBtn && handleSearchButton()}
            >
              Buscar
            </Button>
          </div>
        </div>
      </div>
    </DateFilterContainer>
  );
};

export default DateFilter;